<template>
  <div class="container animate-target" v-animate-in>
    <div class="title animate-target" v-animate-in>
      Part 4
      <hr/>
    </div>
    <h1 class="animate-target" v-animate-in>{{$route.meta.sub_header}}</h1>

    <router-link to="/section4/4-1" class="btn btn_kerendia animate-target" v-animate-in>Continue</router-link>
  </div>
</template>

<script>
export default {
  name: "s4_index"
}
</script>

<style scoped>
@import "../../assets/css/section4/s4.css";
</style>
